module.exports = __webpack_public_path__ + "img/lemon_way_logo.7a87aec8.png";